let SubscriptionsIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The subscriptions page lists the subscriptions for a workflow.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the name of the workflow whose subscriptions being viewed.",
          target: '.campaign_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'Use this button to go to Lead Manager to manually subscribe other leads to a workflow.',
          target: '.add_lead_btn',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'Use this field to search for email addresses',
          target: '.search_field',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the first name of the lead on the subscription",
          target: '.subscription_first_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the last name of the lead on the subscription",
          target: '.subscription_last_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the email of the lead on the subscription",
          target: '.subscription_email',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the phone of the lead on the subscription",
          target: '.subscription_phone',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the status of the subscription",
          target: '.subscription_status',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the version of the subscription",
          target: '.subscription_version',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the last performed_step",
          target: '.subscription_last_performed_step',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to view emails sent by this subscription.",
          target: '.subscription_emails',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to view text messages sent by this subscription.",
          target: '.subscription_sms',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};

export default SubscriptionsIndexTourSteps;
